import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import 'engine/index.css'
import EngineApp from "engine/App";
import {Database} from "engine/types/types";
import theme, {ThemeProvider} from "engine/theme";

const db : Database = require('./active-db.json')

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

theme.colorPrimary = '#FFCC00'
theme.colorSecondary = '#D5A100'
theme.colorPrimaryOpposite = '#000'
theme.colorSkipBackground = '#0075BE'
theme.colorSkipText = '#ffffff'
theme.colorWrong = '#FB1B1B'

function App () {
  return <ThemeProvider theme={theme}>
    <EngineApp
      countdownLabel={'Next Pokémon:'}
      images={db.images}
      answers={db.answers}
      blurSteps={[6,5,4,3,2,1,0,0,0]}
      searchPlaceHolder={'Search'}
      resultTitleWin={(guesses: number) => {
        return `Caught it in ${guesses}!`
      }}
      resultTitleLose={() => 'You Lose'}
      resultCopyHeader={(num: number) => {
        return `#GuessThePokemon #${num}`
      }}
      resultCopyFooter={'https://guessthepokemon.com'}
      title={'Guess the Pokémon'}
      donateLink={'https://ko-fi.com/guessthepokemon'}
    />
  </ThemeProvider>
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
